export const genders = ["male", "female"];
export const features = ["accessories", "body", "ear", "eye", "eyebrow", "eyeLine", "facialHair", "glasses", "hair", "hairBg", "head", "jersey", "miscLine", "mouth", "nose", "smileLine"];
export const races = ["white", "black", "brown", "asian"];